import ga4 from 'react-ga4'

const TRACKING_ID = 'G-XJ6F0PJPKE'
const isProduction = import.meta.env.PROD

export const initGA4 = () =>
  ga4.initialize(TRACKING_ID, {
    testMode: !isProduction,
  })

export const sendEvent = ({
  event_name,
  event_params,
}: {
  event_name: string
  event_params: any
}) => ga4.event(event_name, event_params)

export const configureUser = (user: any) => {
  ga4.gtag('set', 'user_id', String(user.id))
  ga4.gtag('set', 'user_properties', {
    email: user.email,
    first_name: user.first_name,
    last_name: user.last_name,
  })
}

export const sendPageview = (path: string) =>
  ga4.send({
    hitType: 'pageview',
    page: path,
  })

export const GA4 = {
  initGA4,
  sendEvent,
  configureUser,
  sendPageview,
}
